module.exports = __webpack_public_path__ + "img/comp_logo.0dacfa4d.png";